import GaPlugin from './GaPlugin'
import Directive from './directive'

// inCordova, trackingId, appName, appVersion
const install = function (Vue, initConf = {}) {
  if (!initConf.inCordova) {
    var node = document.createElement('script')
    node.setAttribute('async', true)
    node.src = 'https://www.googletagmanager.com/gtag/js?id=' + initConf.trackingId
    document.body.appendChild(node)

    window.dataLayer = window.dataLayer || []
    window.gtag = function () { window.dataLayer.push(arguments) }
    window.gtag('js', new Date())
    window.gtag('config', initConf.trackingId)
    window.gtag('config', initConf.trackingId, { 'send_page_view': false })
  }

  window.gaTrackingId = initConf.trackingId
  window.appName = initConf.appName
  window.gaLogDebug = initConf.logDebug

  if (initConf.vueRouter) {
    initVueRouterGuard(Vue, initConf.vueRouter)
  }
  Vue.directive('ga', Directive)
  Vue.prototype.$analytics = Vue.prototype.$ga = Vue.analytics = new GaPlugin()
}

const initVueRouterGuard = function (Vue, vueRouter) {
  vueRouter.afterEach(to => {
    // Dispatch vue event using meta analytics value if defined otherwise fallback to route name/path.
    Vue.analytics.trackView(to.name, to.path)
    Vue.analytics.trackScreen(to.name)
  })
}

export default { install }
